import script from "./ScrollTop.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollTop.vue?vue&type=script&setup=true&lang=js"

import "./ScrollTop.vue?vue&type=style&index=0&id=4e5631ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e5631ec"]])

export default __exports__